// import {useEffect} from "react"
import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { payment as actions } from "actions";
import { typography, payment as statuses } from "globalConstants";
import { ReduxStates } from "Types";
import { Payment as PaymentType } from "Types/Reducers";

import AtomPaper from "Components/Atoms/Paper";
import AtomH2 from "Components/Atoms/H2";
import AtomButton from "Components/Atoms/Button";

export type PropsType = any;

const Wrap = styled(AtomPaper)`
   padding: 30px 40px;
`;

const SubTitle = styled.span<any>`
   ${typography.other.t7}
   ${({ css }) => css}
`;

const Buttons = styled.div<any>`
   display: grid;
   width: 100%;
   grid-template-columns: 1fr 1fr;
   gap: 13px;
   ${({ css }) => css}
`;
const Button = styled(AtomButton)`
   ${typography.other.t6}
   grid-column: auto / span 1;
   border: 1px solid ${typography.other.color.gray[2]};
   background-color: white;
   color: black;
   box-sizing: border-box;
   width: 100%;
   ${({ css }) => css}
`;

export default function MoleculeFormPayment(props: PropsType) {
   const dispatch = useDispatch();
   const payment = useSelector((state: { [key in keyof ReduxStates]: PaymentType }) => state.payment.type);

   function paymentOnClick(type: typeof statuses[keyof typeof statuses]) {
      const action = type === statuses.card ? actions.setCard : type === statuses.phone ? actions.setPhone : type === statuses.withoutPassbook ? actions.setWithoutPassbook : null;

      console.log("call action", action);
      dispatch({
         type: action,
      });
   }

   const cssHighlight = css`
      background-color: black;
      border: null;
      color: white;
   `;

   const cssCard = payment === statuses.card ? cssHighlight : css``;
   const cssPhone = payment === statuses.phone ? cssHighlight : css``;
   const cssWithoutPassbook = payment === statuses.withoutPassbook ? cssHighlight : css``;

   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <AtomH2>5. 완료/결제 페이지</AtomH2>
         <SubTitle
            css={css`
               margin-top: 30px;
               display: block;
            `}>
            결제수단
         </SubTitle>
         <Buttons
            css={css`
               margin-top: 10px;
            `}>
            <Button onClick={() => paymentOnClick(statuses.withoutPassbook)} css={cssWithoutPassbook}>
               무통장 입금
            </Button>
         </Buttons>
      </Wrap>
   );
}
